import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { TrustedPlaces as TrustedPlacesBase } from "./TrustedPlaces";

export type * from "./TrustedPlaces";
export const TrustedPlaces = withLoyaltyStore(TrustedPlacesBase, "TrustedPlaces");
